import React, { useState } from 'react'

import { Formik } from 'formik'
/* Form & Form Validation */
import * as Yup from 'yup'

import { CloudUploadOutlined } from '@ant-design/icons'

import { PageHeader, Descriptions, Divider, Button } from 'antd'
import { Form, InputNumber, DatePicker, Select } from 'formik-antd'

import { isNotValid, translateSymfonyErrorToFormik } from '../../../../../core/utils/form'
import {
  RANGE_SPECIFIC,
  RANGE_LAST,
  TYPE_MONTH,
  RESULT_TYPE_LIST_SELECT,
  RESULT_TYPE_UNIT
} from '../../../../../config/consts/period'

import Show from './show'
import Moment from 'moment'
import PropTypes from 'prop-types'

const propTypes = {
  updatePeriods: PropTypes.func.isRequired,
}

const defaultProps = {}

const { RangePicker } = DatePicker
const validationSchema = Yup.object().shape({
  period: Yup.string().required('Cannot be blank.'),
  range: Yup.string().required('Cannot be blank.'),
  result: Yup.string().required('Cannot be blank.')
})

const _filter = (input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0

const Formulario = (props) => {
  const goBack = () => props.history.goBack()
  const [periodListQuery, setPeriodListQuery] = useState(null)
  const [periodList, setPeriodList] = useState([])

  const onSubmit = (values, bag) => {
    const month_from = values.limitDate ? Moment(values.limitDate[0]).format('YYYY-MM') : null
    const month_to = values.limitDate ? Moment(values.limitDate[1]).format('YYYY-MM') : null

    const form = {
      period: values.period,
      result: values.result,
      limit: values.limit,
      month_from: month_from,
      month_to: month_to,
      range: values.range,
      unit: values.unit
    }

    const ret = props.updatePeriods(form)

    ret.then((response) => {
      bag.setSubmitting(false)
      if (isNotValid(response)) {
        bag.setErrors(translateSymfonyErrorToFormik(response.errors.children))
      } else {
        setPeriodList(response)
        setPeriodListQuery(form)
      }
    }).catch((e) => {
      //alert("Se ha producido un error desconocido");
    })
  }

  const _initialForm = () => {
    return {
      range: 'LAST',
      limit: 12,
      period: 'MONTH',
      limitDate: null,
      result: '',
      unit: null
    }
  }

  if (periodListQuery) {
    return (
      <>
        <PageHeader
          ghost={false}
          onBack={goBack}
          title='Evolution by periods'
          subTitle='Stats'
          extra={[
            <Button key='save' type='primary' size='small' onClick={() => setPeriodListQuery(null)}>
              Clear
            </Button>
          ]}
        >
          <Descriptions>
            {periodListQuery.range === 'SPECIFIC' && (
              <Descriptions.Item label='Period'>
                {periodListQuery.period} / {periodListQuery.month_from} - {periodListQuery.month_to}
              </Descriptions.Item>
            )}
            {periodListQuery.range === 'LAST' && (
              <Descriptions.Item label='Period'>
                Last {periodListQuery.limit} {periodListQuery.period}
              </Descriptions.Item>
            )}
            <Descriptions.Item label='Result'>{periodListQuery.result}</Descriptions.Item>
          </Descriptions>
        </PageHeader>
        <br />
        <Show {...props} periodListQuery={periodListQuery} periodList={periodList} />
      </>
    )
  }

  return (
    <>
      <Formik initialValues={_initialForm()} validationSchema={validationSchema} onSubmit={onSubmit}>
        {({ values, submitForm, setFieldValue, errors, touched, setFieldTouched, isValid, isSubmitting }) => (
          <Form labelCol={{ xs: 2 }} wrapperCol={{ xs: 16 }}>
            <PageHeader
              ghost={false}
              onBack={goBack}
              title='Evolution by periods'
              subTitle='Stats'
              extra={[
                <Button
                  key='save'
                  type='primary'
                  size='small'
                  onClick={() => submitForm()}
                  disabled={isSubmitting}
                  icon={<CloudUploadOutlined />}
                  loading={isSubmitting}
                >
                  <Divider type='vertical' />
                  {isSubmitting ? 'One moment ...' : 'Create'}
                </Button>
              ]}
            >
              <Form.Item label='Period' name='period' required>
                <Select placeholder='Period' name='period' ize='small'>
                  <Select.Option value={TYPE_MONTH}>MONTH</Select.Option>
                </Select>
              </Form.Item>
              <Form.Item label='Range' name='range' required>
                <Select placeholder='Range' name='range' ize='small'>
                  <Select.Option value={RANGE_LAST}>Last periods</Select.Option>
                  <Select.Option value={RANGE_SPECIFIC}>Specific Range</Select.Option>
                </Select>
              </Form.Item>
              {values.range === RANGE_LAST && (
                <Form.Item label='Limit' name='limit' required>
                  <InputNumber name='limit' placeholder='Limit' min={1} max={48} />
                </Form.Item>
              )}

              {values.range === RANGE_SPECIFIC && (
                <Form.Item label='Limit' name='limitDate' required>
                  <RangePicker name='limitDate' picker='month' ize='small' />
                </Form.Item>
              )}

              <Form.Item label='Result' name='result' required>
                <Select
                  placeholder='Result'
                  name='result'
                  ize='small'
                  options={RESULT_TYPE_LIST_SELECT}
                />
              </Form.Item>

              {values.result === RESULT_TYPE_UNIT && (
                <Form.Item label='Unit' name='unit' hasFeedback required>
                  <Select
                    placeholder='Unit'
                    name='unit'
                    showSearch
                    options={props.units}
                    filterOption={_filter}
                    allowClear
                  />
                </Form.Item>
              )}
            </PageHeader>
          </Form>
        )}
      </Formik>
      <br />
    </>
  )
}

Formulario.propTypes = propTypes
Formulario.defaultProps = defaultProps

export default Formulario
